import type {RenewableNumberRequest, RenewableNumberResponse} from "./renewableNumberRequest";
import {autoRegister, resolve} from "../../container";
import {promiseFromJsonResponse} from "../../common/utils/promises";
import {SecuredRequestExecutor} from "../../module/awswaf/securedRequestExecutor";
import type {SitePowerNumberRequest, SitePowerNumberResponse} from "./sitePowerNumberRequest";

@autoRegister()
export class RenewableEnergyService {

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
    }

    public async getPowerForTechnology(request: RenewableNumberRequest): Promise<RenewableNumberResponse> {
        const getRequest = (): Promise<Response> =>
            fetch(`/enbw-eop/eop-app-renewable-energy/rest/stable/performance/technology/${request.technology}/${request.unit}/${request.precision}`);
        const response = await this.securedRequestExecutor.execute(getRequest);
        return promiseFromJsonResponse(response);
    }

    public async getPowerForSite(request: SitePowerNumberRequest): Promise<SitePowerNumberResponse> {
        const getRequest = (): Promise<Response> =>
            fetch(`/enbw-eop/eop-app-renewable-energy/rest/stable/performance/sites/${encodeURIComponent(request.akc)}/${request.unit}/${request.precision}`);
        const response = await this.securedRequestExecutor.execute(getRequest);
        return promiseFromJsonResponse(response);
    }
}